import { devDockerLoopbackGameSocket } from '../../config/devDockerLoopback';

const socketUrl = devDockerLoopbackGameSocket(process.env.REACT_APP_SOCKET);

// Direct connection to zpar-server (any absolute URL or dev hosts): default Engine.IO path.
// Empty = same-origin CRA proxy → historical path under /api.
const connectsDirectToGameServer =
  /^https?:\/\//i.test(socketUrl) ||
  socketUrl.includes('localhost') ||
  socketUrl.includes('192') ||
  socketUrl.includes('172');

export const socketPath = connectsDirectToGameServer
  ? '/socket.io/'
  : '/api/socket.io/';
